import { Sign } from '@/components/Sign';
import { Summary as SummaryType } from '@/lib/model';
import * as React from 'react';
import './index.scss';

export interface SummaryProps {
  data: SummaryType;
  isSignOpen?: boolean;
  onSignClick?: () => void;
}

export const Summary: React.FC<SummaryProps> = ({
  data,
  isSignOpen,
  onSignClick,
}) => (
  <div className="Summary">
    {Object.keys(data).map((key, i) => {
      const row = data[key as keyof SummaryType];

      return (
        <div className="Summary__row" key={i.toString()}>
          <div>
            <span>{row.label}</span>
            {key === 'turnout' && (
              <Sign isOpen={isSignOpen} onClick={onSignClick} />
            )}
          </div>
          <span>{`${row.value}`}</span>
        </div>
      );
    })}
  </div>
);
